import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { useState } from 'react';
import { MdExpandMore } from 'react-icons/md';
import { toast } from 'react-toastify';

import { queryClient } from '@/App';
import { SuricattaTrainingTableColumnsColumns } from '@/constants/tableColumns/SuricattaTrainingColumns';
// import { suricattaTrainingTableColumnsColumns } from '@/constants/tableColumns/SuricattaTrainingTrainingColumns';
import api from '@/services/apiSgft';
import { SuricattaTrainingData } from '@/types/SuricattaTrainingData';

import DeleteIcon from '../../assets/icons/delete-icon.svg';
import EditIcon from '../../assets/icons/edit-icon.svg';
import { Button } from '../atoms/Button';
import { ConfirmationDialog } from '../atoms/ConfirmationDialog';
import Table from '../organisms/Table';
import { SuricattaTrainingModal } from './SuricattaTrainingModal';

interface SuricattaTrainingCardProps {
	suricattaTraining: SuricattaTrainingData;
}
export const SuricattaTrainingCard = ({
	suricattaTraining,
}: SuricattaTrainingCardProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const [isOpenEdit, setIsOpenEdit] = useState(false);
	const [isOpenDelete, setIsOpenDelete] = useState(false);
	const deleteSuricattaTraining = async () => {
		try {
			await api.delete(`/suricatta-training/${suricattaTraining.id}`);
			toast.success('Treinamento removido com sucesso!', {
				theme: 'colored',
				toastId: 'success',
			});
			queryClient.invalidateQueries(['get-all-suricatta-trainings-data']);
		} catch (e) {
			toast.error('Erro ao remover treinamento!', {
				theme: 'colored',
				toastId: 'error',
			});
		}
		setIsOpenDelete(false);
	};
	return (
		<>
			{isOpenEdit && (
				<SuricattaTrainingModal
					isOpen={isOpenEdit}
					onClose={() => setIsOpenEdit(false)}
					type="edit"
					suricattaTraining={suricattaTraining}
				/>
			)}
			{isOpenDelete && (
				<ConfirmationDialog
					title={'Confirmação da deleção'}
					description={
						'Ao prosseguir com esta ação, o treinamento e todas as suas informações serão removidas do sistema.'
					}
					setIsOpen={setIsOpenDelete}
					onConfirmation={deleteSuricattaTraining}
					height="15rem"
					width="30rem"
				/>
			)}
			<AccordionPrimitive.Root
				type="multiple"
				className="w-full rounded-[10px]"
			>
				<AccordionPrimitive.Item
					value="1"
					className="w-full rounded-[10px] bg-white"
				>
					<AccordionPrimitive.Header className="relative w-full rounded-[10px] bg-white">
						<AccordionPrimitive.Trigger className="group flex w-full grow rounded-[10px] px-5 py-[18px]">
							<div className="flex w-full items-center justify-between">
								<h3 className="max-w-full pr-5 text-justify text-lg font-semibold text-primary">
									{suricattaTraining.name}
								</h3>
								<div className="flex shrink-0">
									<Button
										aria-label="edit"
										variant={'destructive'}
										className="p-2 hover:opacity-90"
										onClick={(e) => {
											e.stopPropagation();
											setIsOpenEdit(true);
										}}
									>
										<img
											src={EditIcon}
											alt="Ícone de editar"
											className="w-5 flex-none"
										/>
									</Button>

									<Button
										aria-label="delete"
										className="p-2 hover:opacity-90"
										variant={'destructive'}
										onClick={(e) => {
											e.stopPropagation();
											setIsOpenDelete(true);
										}}
									>
										<img
											src={DeleteIcon}
											alt="Ícone de deletar"
											className="w-[13px] flex-none"
										/>
									</Button>
									<Button
										aria-label="delete"
										className="p-2 hover:opacity-90"
										variant={'destructive'}
										onClick={() => setIsOpen(!isOpen)}
									>
										<MdExpandMore className=" text-3xl text-primary transition-transform duration-300 ease-[cubic-bezier(0.87,_0,_0.13,_1)] group-data-[state=open]:rotate-180" />
									</Button>
								</div>
							</div>
						</AccordionPrimitive.Trigger>
					</AccordionPrimitive.Header>
					<AccordionPrimitive.Content className="overflow-hidden rounded-[10px] bg-white px-5 text-[15px] data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown">
						<section className="flex flex-col gap-2 pb-4 pt-[10px]">
							<div className="flex flex-col gap-8">
								<Table
									columns={SuricattaTrainingTableColumnsColumns}
									data={suricattaTraining.sgftTrainings}
									isWhiteTable
								/>
							</div>
						</section>
					</AccordionPrimitive.Content>
				</AccordionPrimitive.Item>
			</AccordionPrimitive.Root>
		</>
	);
};
